import { render, staticRenderFns } from "./ViewCandidateApplication.vue?vue&type=template&id=56fac9e6&scoped=true&"
import script from "./ViewCandidateApplication.vue?vue&type=script&lang=js&"
export * from "./ViewCandidateApplication.vue?vue&type=script&lang=js&"
import style0 from "./ViewCandidateApplication.vue?vue&type=style&index=0&id=56fac9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fac9e6",
  null
  
)

export default component.exports